import { useState } from "react";
import { CalendarDays, Plus, Search } from "lucide-react";
import { Chip, Empty, Page, Spinner, useIsDesktop } from "@/components/kit";
import EventsDesktop from "@/pages/EventsDesktop";
import { CreateEventModal } from "@/components/EventPicker";
import { EventRow } from "@/pages/Home";
import { useEvents } from "@/hooks/queries";

export default function Events() {
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [creating, setCreating] = useState(false);
  const events = useEvents({ search: search.trim(), filter, sort: "date" });
  const list = events.data ?? [];
  const isDesktop = useIsDesktop();
  if (isDesktop)
    return (
      <>
        <EventsDesktop search={search} setSearch={setSearch} filter={filter} setFilter={setFilter} list={list} loading={events.isLoading} onCreate={() => setCreating(true)} />
        <CreateEventModal open={creating} onClose={() => setCreating(false)} />
      </>
    );
  return (
    <Page className="pt-4 lg:pt-8">
      <div className="flex items-center justify-between">
        <h1 className="text-[30px] lg:text-4xl font-extrabold">Events</h1>
        <button className="t-btn t-btn-primary h-11 px-4 text-[15px]" onClick={() => setCreating(true)} data-testid="events-create"><Plus className="w-5 h-5" />New Event</button>
      </div>
      <div className="relative mt-4">
        <Search className="absolute left-4 top-[15px] w-5 h-5 text-[#475569]" />
        <input className="t-input pl-12" placeholder="Search events" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="events-search" />
      </div>
      <div className="flex gap-2 mt-4">
        {["all", "upcoming", "past"].map((f) => <Chip key={f} selected={filter === f} onClick={() => setFilter(f)} testid={`events-filter-${f}`}>{f[0].toUpperCase() + f.slice(1)}</Chip>)}
      </div>
      <div className="mt-6 grid grid-cols-1 gap-3 lg:grid-cols-2 xl:grid-cols-3" data-testid="events-list">
        {events.isLoading && <Spinner className="lg:col-span-2" />}
        {list.map((ev) => <EventRow key={ev.id} ev={ev} />)}
      </div>
      {events.isSuccess && !list.length && <Empty icon={CalendarDays} title="No events yet" text="Create an event to group the people you meet there." testid="events-empty" />}
      <CreateEventModal open={creating} onClose={() => setCreating(false)} />
    </Page>
  );
}
